;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();export const symbolNames = [
  "careers/do_it_together",
  "careers/dog",
  "careers/iterate_quickly",
  "careers/know_your_s--t",
  "careers/own_it",
  "careers/values_do_it_together",
  "careers/values_iterate_quickly",
  "careers/values_know_your",
  "careers/values_own_it",
  "country-flags/eu",
  "country-flags/uk",
  "heroicons/micro/academic-cap",
  "heroicons/micro/adjustments-horizontal",
  "heroicons/micro/adjustments-vertical",
  "heroicons/micro/archive-box",
  "heroicons/micro/archive-box-arrow-down",
  "heroicons/micro/archive-box-x-mark",
  "heroicons/micro/arrow-down",
  "heroicons/micro/arrow-down-circle",
  "heroicons/micro/arrow-down-left",
  "heroicons/micro/arrow-down-on-square",
  "heroicons/micro/arrow-down-on-square-stack",
  "heroicons/micro/arrow-down-right",
  "heroicons/micro/arrow-down-tray",
  "heroicons/micro/arrow-left",
  "heroicons/micro/arrow-left-circle",
  "heroicons/micro/arrow-left-end-on-rectangle",
  "heroicons/micro/arrow-left-start-on-rectangle",
  "heroicons/micro/arrow-long-down",
  "heroicons/micro/arrow-long-left",
  "heroicons/micro/arrow-long-right",
  "heroicons/micro/arrow-long-up",
  "heroicons/micro/arrow-path",
  "heroicons/micro/arrow-path-rounded-square",
  "heroicons/micro/arrow-right",
  "heroicons/micro/arrow-right-circle",
  "heroicons/micro/arrow-right-end-on-rectangle",
  "heroicons/micro/arrow-right-start-on-rectangle",
  "heroicons/micro/arrow-top-right-on-square",
  "heroicons/micro/arrow-trending-down",
  "heroicons/micro/arrow-trending-up",
  "heroicons/micro/arrow-turn-down-left",
  "heroicons/micro/arrow-turn-down-right",
  "heroicons/micro/arrow-turn-left-down",
  "heroicons/micro/arrow-turn-left-up",
  "heroicons/micro/arrow-turn-right-down",
  "heroicons/micro/arrow-turn-right-up",
  "heroicons/micro/arrow-turn-up-left",
  "heroicons/micro/arrow-turn-up-right",
  "heroicons/micro/arrow-up",
  "heroicons/micro/arrow-up-circle",
  "heroicons/micro/arrow-up-left",
  "heroicons/micro/arrow-up-on-square",
  "heroicons/micro/arrow-up-on-square-stack",
  "heroicons/micro/arrow-up-right",
  "heroicons/micro/arrow-up-tray",
  "heroicons/micro/arrow-uturn-down",
  "heroicons/micro/arrow-uturn-left",
  "heroicons/micro/arrow-uturn-right",
  "heroicons/micro/arrow-uturn-up",
  "heroicons/micro/arrows-pointing-in",
  "heroicons/micro/arrows-pointing-out",
  "heroicons/micro/arrows-right-left",
  "heroicons/micro/arrows-up-down",
  "heroicons/micro/at-symbol",
  "heroicons/micro/backspace",
  "heroicons/micro/backward",
  "heroicons/micro/banknotes",
  "heroicons/micro/bars-2",
  "heroicons/micro/bars-3",
  "heroicons/micro/bars-3-bottom-left",
  "heroicons/micro/bars-3-bottom-right",
  "heroicons/micro/bars-3-center-left",
  "heroicons/micro/bars-4",
  "heroicons/micro/bars-arrow-down",
  "heroicons/micro/bars-arrow-up",
  "heroicons/micro/battery-0",
  "heroicons/micro/battery-100",
  "heroicons/micro/battery-50",
  "heroicons/micro/beaker",
  "heroicons/micro/bell",
  "heroicons/micro/bell-alert",
  "heroicons/micro/bell-slash",
  "heroicons/micro/bell-snooze",
  "heroicons/micro/bold",
  "heroicons/micro/bolt",
  "heroicons/micro/bolt-slash",
  "heroicons/micro/book-open",
  "heroicons/micro/bookmark",
  "heroicons/micro/bookmark-slash",
  "heroicons/micro/bookmark-square",
  "heroicons/micro/briefcase",
  "heroicons/micro/bug-ant",
  "heroicons/micro/building-library",
  "heroicons/micro/building-office",
  "heroicons/micro/building-office-2",
  "heroicons/micro/building-storefront",
  "heroicons/micro/cake",
  "heroicons/micro/calculator",
  "heroicons/micro/calendar",
  "heroicons/micro/calendar-date-range",
  "heroicons/micro/calendar-days",
  "heroicons/micro/camera",
  "heroicons/micro/chart-bar",
  "heroicons/micro/chart-bar-square",
  "heroicons/micro/chart-pie",
  "heroicons/micro/chat-bubble-bottom-center",
  "heroicons/micro/chat-bubble-bottom-center-text",
  "heroicons/micro/chat-bubble-left",
  "heroicons/micro/chat-bubble-left-ellipsis",
  "heroicons/micro/chat-bubble-left-right",
  "heroicons/micro/chat-bubble-oval-left",
  "heroicons/micro/chat-bubble-oval-left-ellipsis",
  "heroicons/micro/check",
  "heroicons/micro/check-badge",
  "heroicons/micro/check-circle",
  "heroicons/micro/chevron-double-down",
  "heroicons/micro/chevron-double-left",
  "heroicons/micro/chevron-double-right",
  "heroicons/micro/chevron-double-up",
  "heroicons/micro/chevron-down",
  "heroicons/micro/chevron-left",
  "heroicons/micro/chevron-right",
  "heroicons/micro/chevron-up",
  "heroicons/micro/chevron-up-down",
  "heroicons/micro/circle-stack",
  "heroicons/micro/clipboard",
  "heroicons/micro/clipboard-document",
  "heroicons/micro/clipboard-document-check",
  "heroicons/micro/clipboard-document-list",
  "heroicons/micro/clock",
  "heroicons/micro/cloud",
  "heroicons/micro/cloud-arrow-down",
  "heroicons/micro/cloud-arrow-up",
  "heroicons/micro/code-bracket",
  "heroicons/micro/code-bracket-square",
  "heroicons/micro/cog",
  "heroicons/micro/cog-6-tooth",
  "heroicons/micro/cog-8-tooth",
  "heroicons/micro/command-line",
  "heroicons/micro/computer-desktop",
  "heroicons/micro/cpu-chip",
  "heroicons/micro/credit-card",
  "heroicons/micro/cube",
  "heroicons/micro/cube-transparent",
  "heroicons/micro/currency-bangladeshi",
  "heroicons/micro/currency-dollar",
  "heroicons/micro/currency-euro",
  "heroicons/micro/currency-pound",
  "heroicons/micro/currency-rupee",
  "heroicons/micro/currency-yen",
  "heroicons/micro/cursor-arrow-rays",
  "heroicons/micro/cursor-arrow-ripple",
  "heroicons/micro/device-phone-mobile",
  "heroicons/micro/device-tablet",
  "heroicons/micro/divide",
  "heroicons/micro/document",
  "heroicons/micro/document-arrow-down",
  "heroicons/micro/document-arrow-up",
  "heroicons/micro/document-chart-bar",
  "heroicons/micro/document-check",
  "heroicons/micro/document-currency-bangladeshi",
  "heroicons/micro/document-currency-dollar",
  "heroicons/micro/document-currency-euro",
  "heroicons/micro/document-currency-pound",
  "heroicons/micro/document-currency-rupee",
  "heroicons/micro/document-currency-yen",
  "heroicons/micro/document-duplicate",
  "heroicons/micro/document-magnifying-glass",
  "heroicons/micro/document-minus",
  "heroicons/micro/document-plus",
  "heroicons/micro/document-text",
  "heroicons/micro/ellipsis-horizontal",
  "heroicons/micro/ellipsis-horizontal-circle",
  "heroicons/micro/ellipsis-vertical",
  "heroicons/micro/envelope",
  "heroicons/micro/envelope-open",
  "heroicons/micro/equals",
  "heroicons/micro/exclamation-circle",
  "heroicons/micro/exclamation-triangle",
  "heroicons/micro/eye",
  "heroicons/micro/eye-dropper",
  "heroicons/micro/eye-slash",
  "heroicons/micro/face-frown",
  "heroicons/micro/face-smile",
  "heroicons/micro/film",
  "heroicons/micro/finger-print",
  "heroicons/micro/fire",
  "heroicons/micro/flag",
  "heroicons/micro/folder",
  "heroicons/micro/folder-arrow-down",
  "heroicons/micro/folder-minus",
  "heroicons/micro/folder-open",
  "heroicons/micro/folder-plus",
  "heroicons/micro/forward",
  "heroicons/micro/funnel",
  "heroicons/micro/gif",
  "heroicons/micro/gift",
  "heroicons/micro/gift-top",
  "heroicons/micro/globe-alt",
  "heroicons/micro/globe-americas",
  "heroicons/micro/globe-asia-australia",
  "heroicons/micro/globe-europe-africa",
  "heroicons/micro/h1",
  "heroicons/micro/h2",
  "heroicons/micro/h3",
  "heroicons/micro/hand-raised",
  "heroicons/micro/hand-thumb-down",
  "heroicons/micro/hand-thumb-up",
  "heroicons/micro/hashtag",
  "heroicons/micro/heart",
  "heroicons/micro/home",
  "heroicons/micro/home-modern",
  "heroicons/micro/identification",
  "heroicons/micro/inbox",
  "heroicons/micro/inbox-arrow-down",
  "heroicons/micro/inbox-stack",
  "heroicons/micro/information-circle",
  "heroicons/micro/italic",
  "heroicons/micro/key",
  "heroicons/micro/language",
  "heroicons/micro/lifebuoy",
  "heroicons/micro/light-bulb",
  "heroicons/micro/link",
  "heroicons/micro/link-slash",
  "heroicons/micro/list-bullet",
  "heroicons/micro/lock-closed",
  "heroicons/micro/lock-open",
  "heroicons/micro/magnifying-glass",
  "heroicons/micro/magnifying-glass-circle",
  "heroicons/micro/magnifying-glass-minus",
  "heroicons/micro/magnifying-glass-plus",
  "heroicons/micro/map",
  "heroicons/micro/map-pin",
  "heroicons/micro/megaphone",
  "heroicons/micro/microphone",
  "heroicons/micro/minus",
  "heroicons/micro/minus-circle",
  "heroicons/micro/moon",
  "heroicons/micro/musical-note",
  "heroicons/micro/newspaper",
  "heroicons/micro/no-symbol",
  "heroicons/micro/numbered-list",
  "heroicons/micro/paint-brush",
  "heroicons/micro/paper-airplane",
  "heroicons/micro/paper-clip",
  "heroicons/micro/pause",
  "heroicons/micro/pause-circle",
  "heroicons/micro/pencil",
  "heroicons/micro/pencil-square",
  "heroicons/micro/percent-badge",
  "heroicons/micro/phone",
  "heroicons/micro/phone-arrow-down-left",
  "heroicons/micro/phone-arrow-up-right",
  "heroicons/micro/phone-x-mark",
  "heroicons/micro/photo",
  "heroicons/micro/play",
  "heroicons/micro/play-circle",
  "heroicons/micro/play-pause",
  "heroicons/micro/plus",
  "heroicons/micro/plus-circle",
  "heroicons/micro/power",
  "heroicons/micro/presentation-chart-bar",
  "heroicons/micro/presentation-chart-line",
  "heroicons/micro/printer",
  "heroicons/micro/puzzle-piece",
  "heroicons/micro/qr-code",
  "heroicons/micro/question-mark-circle",
  "heroicons/micro/queue-list",
  "heroicons/micro/radio",
  "heroicons/micro/receipt-percent",
  "heroicons/micro/receipt-refund",
  "heroicons/micro/rectangle-group",
  "heroicons/micro/rectangle-stack",
  "heroicons/micro/rocket-launch",
  "heroicons/micro/rss",
  "heroicons/micro/scale",
  "heroicons/micro/scissors",
  "heroicons/micro/server",
  "heroicons/micro/server-stack",
  "heroicons/micro/share",
  "heroicons/micro/shield-check",
  "heroicons/micro/shield-exclamation",
  "heroicons/micro/shopping-bag",
  "heroicons/micro/shopping-cart",
  "heroicons/micro/signal",
  "heroicons/micro/signal-slash",
  "heroicons/micro/slash",
  "heroicons/micro/sparkles",
  "heroicons/micro/speaker-wave",
  "heroicons/micro/speaker-x-mark",
  "heroicons/micro/square-2-stack",
  "heroicons/micro/square-3-stack-3d",
  "heroicons/micro/squares-2x2",
  "heroicons/micro/squares-plus",
  "heroicons/micro/star",
  "heroicons/micro/stop",
  "heroicons/micro/stop-circle",
  "heroicons/micro/strikethrough",
  "heroicons/micro/sun",
  "heroicons/micro/swatch",
  "heroicons/micro/table-cells",
  "heroicons/micro/tag",
  "heroicons/micro/ticket",
  "heroicons/micro/trash",
  "heroicons/micro/trophy",
  "heroicons/micro/truck",
  "heroicons/micro/tv",
  "heroicons/micro/underline",
  "heroicons/micro/user",
  "heroicons/micro/user-circle",
  "heroicons/micro/user-group",
  "heroicons/micro/user-minus",
  "heroicons/micro/user-plus",
  "heroicons/micro/users",
  "heroicons/micro/variable",
  "heroicons/micro/video-camera",
  "heroicons/micro/video-camera-slash",
  "heroicons/micro/view-columns",
  "heroicons/micro/viewfinder-circle",
  "heroicons/micro/wallet",
  "heroicons/micro/wifi",
  "heroicons/micro/window",
  "heroicons/micro/wrench",
  "heroicons/micro/wrench-screwdriver",
  "heroicons/micro/x-circle",
  "heroicons/micro/x-mark",
  "heroicons/outline/academic-cap",
  "heroicons/outline/adjustments-horizontal",
  "heroicons/outline/adjustments-vertical",
  "heroicons/outline/archive-box",
  "heroicons/outline/archive-box-arrow-down",
  "heroicons/outline/archive-box-x-mark",
  "heroicons/outline/arrow-down",
  "heroicons/outline/arrow-down-circle",
  "heroicons/outline/arrow-down-left",
  "heroicons/outline/arrow-down-on-square",
  "heroicons/outline/arrow-down-on-square-stack",
  "heroicons/outline/arrow-down-right",
  "heroicons/outline/arrow-down-tray",
  "heroicons/outline/arrow-left",
  "heroicons/outline/arrow-left-circle",
  "heroicons/outline/arrow-left-end-on-rectangle",
  "heroicons/outline/arrow-left-on-rectangle",
  "heroicons/outline/arrow-left-start-on-rectangle",
  "heroicons/outline/arrow-long-down",
  "heroicons/outline/arrow-long-left",
  "heroicons/outline/arrow-long-right",
  "heroicons/outline/arrow-long-up",
  "heroicons/outline/arrow-path",
  "heroicons/outline/arrow-path-rounded-square",
  "heroicons/outline/arrow-right",
  "heroicons/outline/arrow-right-circle",
  "heroicons/outline/arrow-right-end-on-rectangle",
  "heroicons/outline/arrow-right-on-rectangle",
  "heroicons/outline/arrow-right-start-on-rectangle",
  "heroicons/outline/arrow-small-down",
  "heroicons/outline/arrow-small-left",
  "heroicons/outline/arrow-small-right",
  "heroicons/outline/arrow-small-up",
  "heroicons/outline/arrow-top-right-on-square",
  "heroicons/outline/arrow-trending-down",
  "heroicons/outline/arrow-trending-up",
  "heroicons/outline/arrow-turn-down-left",
  "heroicons/outline/arrow-turn-down-right",
  "heroicons/outline/arrow-turn-left-down",
  "heroicons/outline/arrow-turn-left-up",
  "heroicons/outline/arrow-turn-right-down",
  "heroicons/outline/arrow-turn-right-up",
  "heroicons/outline/arrow-turn-up-left",
  "heroicons/outline/arrow-turn-up-right",
  "heroicons/outline/arrow-up",
  "heroicons/outline/arrow-up-circle",
  "heroicons/outline/arrow-up-left",
  "heroicons/outline/arrow-up-on-square",
  "heroicons/outline/arrow-up-on-square-stack",
  "heroicons/outline/arrow-up-right",
  "heroicons/outline/arrow-up-tray",
  "heroicons/outline/arrow-uturn-down",
  "heroicons/outline/arrow-uturn-left",
  "heroicons/outline/arrow-uturn-right",
  "heroicons/outline/arrow-uturn-up",
  "heroicons/outline/arrows-pointing-in",
  "heroicons/outline/arrows-pointing-out",
  "heroicons/outline/arrows-right-left",
  "heroicons/outline/arrows-up-down",
  "heroicons/outline/at-symbol",
  "heroicons/outline/backspace",
  "heroicons/outline/backward",
  "heroicons/outline/banknotes",
  "heroicons/outline/bars-2",
  "heroicons/outline/bars-3",
  "heroicons/outline/bars-3-bottom-left",
  "heroicons/outline/bars-3-bottom-right",
  "heroicons/outline/bars-3-center-left",
  "heroicons/outline/bars-4",
  "heroicons/outline/bars-arrow-down",
  "heroicons/outline/bars-arrow-up",
  "heroicons/outline/battery-0",
  "heroicons/outline/battery-100",
  "heroicons/outline/battery-50",
  "heroicons/outline/beaker",
  "heroicons/outline/bell",
  "heroicons/outline/bell-alert",
  "heroicons/outline/bell-slash",
  "heroicons/outline/bell-snooze",
  "heroicons/outline/bold",
  "heroicons/outline/bolt",
  "heroicons/outline/bolt-slash",
  "heroicons/outline/book-open",
  "heroicons/outline/bookmark",
  "heroicons/outline/bookmark-slash",
  "heroicons/outline/bookmark-square",
  "heroicons/outline/briefcase",
  "heroicons/outline/bug-ant",
  "heroicons/outline/building-library",
  "heroicons/outline/building-office",
  "heroicons/outline/building-office-2",
  "heroicons/outline/building-storefront",
  "heroicons/outline/cake",
  "heroicons/outline/calculator",
  "heroicons/outline/calendar",
  "heroicons/outline/calendar-date-range",
  "heroicons/outline/calendar-days",
  "heroicons/outline/camera",
  "heroicons/outline/chart-bar",
  "heroicons/outline/chart-bar-square",
  "heroicons/outline/chart-pie",
  "heroicons/outline/chat-bubble-bottom-center",
  "heroicons/outline/chat-bubble-bottom-center-text",
  "heroicons/outline/chat-bubble-left",
  "heroicons/outline/chat-bubble-left-ellipsis",
  "heroicons/outline/chat-bubble-left-right",
  "heroicons/outline/chat-bubble-oval-left",
  "heroicons/outline/chat-bubble-oval-left-ellipsis",
  "heroicons/outline/check",
  "heroicons/outline/check-badge",
  "heroicons/outline/check-circle",
  "heroicons/outline/chevron-double-down",
  "heroicons/outline/chevron-double-left",
  "heroicons/outline/chevron-double-right",
  "heroicons/outline/chevron-double-up",
  "heroicons/outline/chevron-down",
  "heroicons/outline/chevron-left",
  "heroicons/outline/chevron-right",
  "heroicons/outline/chevron-up",
  "heroicons/outline/chevron-up-down",
  "heroicons/outline/circle-stack",
  "heroicons/outline/clipboard",
  "heroicons/outline/clipboard-document",
  "heroicons/outline/clipboard-document-check",
  "heroicons/outline/clipboard-document-list",
  "heroicons/outline/clock",
  "heroicons/outline/cloud",
  "heroicons/outline/cloud-arrow-down",
  "heroicons/outline/cloud-arrow-up",
  "heroicons/outline/code-bracket",
  "heroicons/outline/code-bracket-square",
  "heroicons/outline/cog",
  "heroicons/outline/cog-6-tooth",
  "heroicons/outline/cog-8-tooth",
  "heroicons/outline/command-line",
  "heroicons/outline/computer-desktop",
  "heroicons/outline/cpu-chip",
  "heroicons/outline/credit-card",
  "heroicons/outline/cube",
  "heroicons/outline/cube-transparent",
  "heroicons/outline/currency-bangladeshi",
  "heroicons/outline/currency-dollar",
  "heroicons/outline/currency-euro",
  "heroicons/outline/currency-pound",
  "heroicons/outline/currency-rupee",
  "heroicons/outline/currency-yen",
  "heroicons/outline/cursor-arrow-rays",
  "heroicons/outline/cursor-arrow-ripple",
  "heroicons/outline/device-phone-mobile",
  "heroicons/outline/device-tablet",
  "heroicons/outline/divide",
  "heroicons/outline/document",
  "heroicons/outline/document-arrow-down",
  "heroicons/outline/document-arrow-up",
  "heroicons/outline/document-chart-bar",
  "heroicons/outline/document-check",
  "heroicons/outline/document-currency-bangladeshi",
  "heroicons/outline/document-currency-dollar",
  "heroicons/outline/document-currency-euro",
  "heroicons/outline/document-currency-pound",
  "heroicons/outline/document-currency-rupee",
  "heroicons/outline/document-currency-yen",
  "heroicons/outline/document-duplicate",
  "heroicons/outline/document-magnifying-glass",
  "heroicons/outline/document-minus",
  "heroicons/outline/document-plus",
  "heroicons/outline/document-text",
  "heroicons/outline/ellipsis-horizontal",
  "heroicons/outline/ellipsis-horizontal-circle",
  "heroicons/outline/ellipsis-vertical",
  "heroicons/outline/envelope",
  "heroicons/outline/envelope-open",
  "heroicons/outline/equals",
  "heroicons/outline/exclamation-circle",
  "heroicons/outline/exclamation-triangle",
  "heroicons/outline/eye",
  "heroicons/outline/eye-dropper",
  "heroicons/outline/eye-slash",
  "heroicons/outline/face-frown",
  "heroicons/outline/face-smile",
  "heroicons/outline/film",
  "heroicons/outline/finger-print",
  "heroicons/outline/fire",
  "heroicons/outline/flag",
  "heroicons/outline/folder",
  "heroicons/outline/folder-arrow-down",
  "heroicons/outline/folder-minus",
  "heroicons/outline/folder-open",
  "heroicons/outline/folder-plus",
  "heroicons/outline/forward",
  "heroicons/outline/funnel",
  "heroicons/outline/gif",
  "heroicons/outline/gift",
  "heroicons/outline/gift-top",
  "heroicons/outline/globe-alt",
  "heroicons/outline/globe-americas",
  "heroicons/outline/globe-asia-australia",
  "heroicons/outline/globe-europe-africa",
  "heroicons/outline/h1",
  "heroicons/outline/h2",
  "heroicons/outline/h3",
  "heroicons/outline/hand-raised",
  "heroicons/outline/hand-thumb-down",
  "heroicons/outline/hand-thumb-up",
  "heroicons/outline/hashtag",
  "heroicons/outline/heart",
  "heroicons/outline/home",
  "heroicons/outline/home-modern",
  "heroicons/outline/identification",
  "heroicons/outline/inbox",
  "heroicons/outline/inbox-arrow-down",
  "heroicons/outline/inbox-stack",
  "heroicons/outline/information-circle",
  "heroicons/outline/italic",
  "heroicons/outline/key",
  "heroicons/outline/language",
  "heroicons/outline/lifebuoy",
  "heroicons/outline/light-bulb",
  "heroicons/outline/link",
  "heroicons/outline/link-slash",
  "heroicons/outline/list-bullet",
  "heroicons/outline/lock-closed",
  "heroicons/outline/lock-open",
  "heroicons/outline/magnifying-glass",
  "heroicons/outline/magnifying-glass-circle",
  "heroicons/outline/magnifying-glass-minus",
  "heroicons/outline/magnifying-glass-plus",
  "heroicons/outline/map",
  "heroicons/outline/map-pin",
  "heroicons/outline/megaphone",
  "heroicons/outline/microphone",
  "heroicons/outline/minus",
  "heroicons/outline/minus-circle",
  "heroicons/outline/minus-small",
  "heroicons/outline/moon",
  "heroicons/outline/musical-note",
  "heroicons/outline/newspaper",
  "heroicons/outline/no-symbol",
  "heroicons/outline/numbered-list",
  "heroicons/outline/paint-brush",
  "heroicons/outline/paper-airplane",
  "heroicons/outline/paper-clip",
  "heroicons/outline/pause",
  "heroicons/outline/pause-circle",
  "heroicons/outline/pencil",
  "heroicons/outline/pencil-square",
  "heroicons/outline/percent-badge",
  "heroicons/outline/phone",
  "heroicons/outline/phone-arrow-down-left",
  "heroicons/outline/phone-arrow-up-right",
  "heroicons/outline/phone-x-mark",
  "heroicons/outline/photo",
  "heroicons/outline/play",
  "heroicons/outline/play-circle",
  "heroicons/outline/play-pause",
  "heroicons/outline/plus",
  "heroicons/outline/plus-circle",
  "heroicons/outline/plus-small",
  "heroicons/outline/power",
  "heroicons/outline/presentation-chart-bar",
  "heroicons/outline/presentation-chart-line",
  "heroicons/outline/printer",
  "heroicons/outline/puzzle-piece",
  "heroicons/outline/qr-code",
  "heroicons/outline/question-mark-circle",
  "heroicons/outline/queue-list",
  "heroicons/outline/radio",
  "heroicons/outline/receipt-percent",
  "heroicons/outline/receipt-refund",
  "heroicons/outline/rectangle-group",
  "heroicons/outline/rectangle-stack",
  "heroicons/outline/rocket-launch",
  "heroicons/outline/rss",
  "heroicons/outline/scale",
  "heroicons/outline/scissors",
  "heroicons/outline/server",
  "heroicons/outline/server-stack",
  "heroicons/outline/share",
  "heroicons/outline/shield-check",
  "heroicons/outline/shield-check-thinner",
  "heroicons/outline/shield-exclamation",
  "heroicons/outline/shopping-bag",
  "heroicons/outline/shopping-cart",
  "heroicons/outline/signal",
  "heroicons/outline/signal-slash",
  "heroicons/outline/slash",
  "heroicons/outline/sparkles",
  "heroicons/outline/speaker-wave",
  "heroicons/outline/speaker-x-mark",
  "heroicons/outline/square-2-stack",
  "heroicons/outline/square-3-stack-3d",
  "heroicons/outline/squares-2x2",
  "heroicons/outline/squares-plus",
  "heroicons/outline/star",
  "heroicons/outline/stop",
  "heroicons/outline/stop-circle",
  "heroicons/outline/strikethrough",
  "heroicons/outline/sun",
  "heroicons/outline/swatch",
  "heroicons/outline/table-cells",
  "heroicons/outline/tag",
  "heroicons/outline/ticket",
  "heroicons/outline/trash",
  "heroicons/outline/trophy",
  "heroicons/outline/truck",
  "heroicons/outline/tv",
  "heroicons/outline/underline",
  "heroicons/outline/user",
  "heroicons/outline/user-circle",
  "heroicons/outline/user-group",
  "heroicons/outline/user-minus",
  "heroicons/outline/user-plus",
  "heroicons/outline/users",
  "heroicons/outline/variable",
  "heroicons/outline/video-camera",
  "heroicons/outline/video-camera-slash",
  "heroicons/outline/view-columns",
  "heroicons/outline/viewfinder-circle",
  "heroicons/outline/wallet",
  "heroicons/outline/wifi",
  "heroicons/outline/window",
  "heroicons/outline/wrench",
  "heroicons/outline/wrench-screwdriver",
  "heroicons/outline/x-circle",
  "heroicons/outline/x-mark",
  "heroicons/solid/academic-cap",
  "heroicons/solid/adjustments-horizontal",
  "heroicons/solid/adjustments-vertical",
  "heroicons/solid/archive-box",
  "heroicons/solid/archive-box-arrow-down",
  "heroicons/solid/archive-box-x-mark",
  "heroicons/solid/arrow-down",
  "heroicons/solid/arrow-down-circle",
  "heroicons/solid/arrow-down-left",
  "heroicons/solid/arrow-down-on-square",
  "heroicons/solid/arrow-down-on-square-stack",
  "heroicons/solid/arrow-down-right",
  "heroicons/solid/arrow-down-tray",
  "heroicons/solid/arrow-left",
  "heroicons/solid/arrow-left-circle",
  "heroicons/solid/arrow-left-end-on-rectangle",
  "heroicons/solid/arrow-left-on-rectangle",
  "heroicons/solid/arrow-left-start-on-rectangle",
  "heroicons/solid/arrow-long-down",
  "heroicons/solid/arrow-long-left",
  "heroicons/solid/arrow-long-right",
  "heroicons/solid/arrow-long-up",
  "heroicons/solid/arrow-path",
  "heroicons/solid/arrow-path-rounded-square",
  "heroicons/solid/arrow-right",
  "heroicons/solid/arrow-right-circle",
  "heroicons/solid/arrow-right-end-on-rectangle",
  "heroicons/solid/arrow-right-on-rectangle",
  "heroicons/solid/arrow-right-start-on-rectangle",
  "heroicons/solid/arrow-small-down",
  "heroicons/solid/arrow-small-left",
  "heroicons/solid/arrow-small-right",
  "heroicons/solid/arrow-small-up",
  "heroicons/solid/arrow-top-right-on-square",
  "heroicons/solid/arrow-trending-down",
  "heroicons/solid/arrow-trending-up",
  "heroicons/solid/arrow-turn-down-left",
  "heroicons/solid/arrow-turn-down-right",
  "heroicons/solid/arrow-turn-left-down",
  "heroicons/solid/arrow-turn-left-up",
  "heroicons/solid/arrow-turn-right-down",
  "heroicons/solid/arrow-turn-right-up",
  "heroicons/solid/arrow-turn-up-left",
  "heroicons/solid/arrow-turn-up-right",
  "heroicons/solid/arrow-up",
  "heroicons/solid/arrow-up-circle",
  "heroicons/solid/arrow-up-left",
  "heroicons/solid/arrow-up-on-square",
  "heroicons/solid/arrow-up-on-square-stack",
  "heroicons/solid/arrow-up-right",
  "heroicons/solid/arrow-up-tray",
  "heroicons/solid/arrow-uturn-down",
  "heroicons/solid/arrow-uturn-left",
  "heroicons/solid/arrow-uturn-right",
  "heroicons/solid/arrow-uturn-up",
  "heroicons/solid/arrows-pointing-in",
  "heroicons/solid/arrows-pointing-out",
  "heroicons/solid/arrows-right-left",
  "heroicons/solid/arrows-up-down",
  "heroicons/solid/at-symbol",
  "heroicons/solid/backspace",
  "heroicons/solid/backward",
  "heroicons/solid/banknotes",
  "heroicons/solid/bars-2",
  "heroicons/solid/bars-3",
  "heroicons/solid/bars-3-bottom-left",
  "heroicons/solid/bars-3-bottom-right",
  "heroicons/solid/bars-3-center-left",
  "heroicons/solid/bars-4",
  "heroicons/solid/bars-arrow-down",
  "heroicons/solid/bars-arrow-up",
  "heroicons/solid/battery-0",
  "heroicons/solid/battery-100",
  "heroicons/solid/battery-50",
  "heroicons/solid/beaker",
  "heroicons/solid/bell",
  "heroicons/solid/bell-alert",
  "heroicons/solid/bell-slash",
  "heroicons/solid/bell-snooze",
  "heroicons/solid/bold",
  "heroicons/solid/bolt",
  "heroicons/solid/bolt-slash",
  "heroicons/solid/book-open",
  "heroicons/solid/bookmark",
  "heroicons/solid/bookmark-slash",
  "heroicons/solid/bookmark-square",
  "heroicons/solid/briefcase",
  "heroicons/solid/bug-ant",
  "heroicons/solid/building-library",
  "heroicons/solid/building-office",
  "heroicons/solid/building-office-2",
  "heroicons/solid/building-storefront",
  "heroicons/solid/cake",
  "heroicons/solid/calculator",
  "heroicons/solid/calendar",
  "heroicons/solid/calendar-date-range",
  "heroicons/solid/calendar-days",
  "heroicons/solid/camera",
  "heroicons/solid/chart-bar",
  "heroicons/solid/chart-bar-square",
  "heroicons/solid/chart-pie",
  "heroicons/solid/chat-bubble-bottom-center",
  "heroicons/solid/chat-bubble-bottom-center-text",
  "heroicons/solid/chat-bubble-left",
  "heroicons/solid/chat-bubble-left-ellipsis",
  "heroicons/solid/chat-bubble-left-right",
  "heroicons/solid/chat-bubble-oval-left",
  "heroicons/solid/chat-bubble-oval-left-ellipsis",
  "heroicons/solid/check",
  "heroicons/solid/check-badge",
  "heroicons/solid/check-circle",
  "heroicons/solid/chevron-double-down",
  "heroicons/solid/chevron-double-left",
  "heroicons/solid/chevron-double-right",
  "heroicons/solid/chevron-double-up",
  "heroicons/solid/chevron-down",
  "heroicons/solid/chevron-left",
  "heroicons/solid/chevron-right",
  "heroicons/solid/chevron-up",
  "heroicons/solid/chevron-up-down",
  "heroicons/solid/circle-stack",
  "heroicons/solid/clipboard",
  "heroicons/solid/clipboard-document",
  "heroicons/solid/clipboard-document-check",
  "heroicons/solid/clipboard-document-list",
  "heroicons/solid/clock",
  "heroicons/solid/cloud",
  "heroicons/solid/cloud-arrow-down",
  "heroicons/solid/cloud-arrow-up",
  "heroicons/solid/code-bracket",
  "heroicons/solid/code-bracket-square",
  "heroicons/solid/cog",
  "heroicons/solid/cog-6-tooth",
  "heroicons/solid/cog-8-tooth",
  "heroicons/solid/command-line",
  "heroicons/solid/computer-desktop",
  "heroicons/solid/cpu-chip",
  "heroicons/solid/credit-card",
  "heroicons/solid/cube",
  "heroicons/solid/cube-transparent",
  "heroicons/solid/currency-bangladeshi",
  "heroicons/solid/currency-dollar",
  "heroicons/solid/currency-euro",
  "heroicons/solid/currency-pound",
  "heroicons/solid/currency-rupee",
  "heroicons/solid/currency-yen",
  "heroicons/solid/cursor-arrow-rays",
  "heroicons/solid/cursor-arrow-ripple",
  "heroicons/solid/device-phone-mobile",
  "heroicons/solid/device-tablet",
  "heroicons/solid/divide",
  "heroicons/solid/document",
  "heroicons/solid/document-arrow-down",
  "heroicons/solid/document-arrow-up",
  "heroicons/solid/document-chart-bar",
  "heroicons/solid/document-check",
  "heroicons/solid/document-currency-bangladeshi",
  "heroicons/solid/document-currency-dollar",
  "heroicons/solid/document-currency-euro",
  "heroicons/solid/document-currency-pound",
  "heroicons/solid/document-currency-rupee",
  "heroicons/solid/document-currency-yen",
  "heroicons/solid/document-duplicate",
  "heroicons/solid/document-magnifying-glass",
  "heroicons/solid/document-minus",
  "heroicons/solid/document-plus",
  "heroicons/solid/document-text",
  "heroicons/solid/ellipsis-horizontal",
  "heroicons/solid/ellipsis-horizontal-circle",
  "heroicons/solid/ellipsis-vertical",
  "heroicons/solid/envelope",
  "heroicons/solid/envelope-open",
  "heroicons/solid/equals",
  "heroicons/solid/exclamation-circle",
  "heroicons/solid/exclamation-triangle",
  "heroicons/solid/eye",
  "heroicons/solid/eye-dropper",
  "heroicons/solid/eye-slash",
  "heroicons/solid/face-frown",
  "heroicons/solid/face-smile",
  "heroicons/solid/film",
  "heroicons/solid/finger-print",
  "heroicons/solid/fire",
  "heroicons/solid/flag",
  "heroicons/solid/folder",
  "heroicons/solid/folder-arrow-down",
  "heroicons/solid/folder-minus",
  "heroicons/solid/folder-open",
  "heroicons/solid/folder-plus",
  "heroicons/solid/forward",
  "heroicons/solid/funnel",
  "heroicons/solid/gif",
  "heroicons/solid/gift",
  "heroicons/solid/gift-top",
  "heroicons/solid/globe-alt",
  "heroicons/solid/globe-americas",
  "heroicons/solid/globe-asia-australia",
  "heroicons/solid/globe-europe-africa",
  "heroicons/solid/h1",
  "heroicons/solid/h2",
  "heroicons/solid/h3",
  "heroicons/solid/hand-raised",
  "heroicons/solid/hand-thumb-down",
  "heroicons/solid/hand-thumb-up",
  "heroicons/solid/hashtag",
  "heroicons/solid/heart",
  "heroicons/solid/home",
  "heroicons/solid/home-modern",
  "heroicons/solid/identification",
  "heroicons/solid/inbox",
  "heroicons/solid/inbox-arrow-down",
  "heroicons/solid/inbox-stack",
  "heroicons/solid/information-circle",
  "heroicons/solid/italic",
  "heroicons/solid/key",
  "heroicons/solid/language",
  "heroicons/solid/lifebuoy",
  "heroicons/solid/light-bulb",
  "heroicons/solid/link",
  "heroicons/solid/link-slash",
  "heroicons/solid/list-bullet",
  "heroicons/solid/lock-closed",
  "heroicons/solid/lock-open",
  "heroicons/solid/magnifying-glass",
  "heroicons/solid/magnifying-glass-circle",
  "heroicons/solid/magnifying-glass-minus",
  "heroicons/solid/magnifying-glass-plus",
  "heroicons/solid/map",
  "heroicons/solid/map-pin",
  "heroicons/solid/megaphone",
  "heroicons/solid/microphone",
  "heroicons/solid/minus",
  "heroicons/solid/minus-circle",
  "heroicons/solid/minus-small",
  "heroicons/solid/moon",
  "heroicons/solid/musical-note",
  "heroicons/solid/newspaper",
  "heroicons/solid/no-symbol",
  "heroicons/solid/numbered-list",
  "heroicons/solid/paint-brush",
  "heroicons/solid/paper-airplane",
  "heroicons/solid/paper-clip",
  "heroicons/solid/pause",
  "heroicons/solid/pause-circle",
  "heroicons/solid/pencil",
  "heroicons/solid/pencil-square",
  "heroicons/solid/percent-badge",
  "heroicons/solid/phone",
  "heroicons/solid/phone-arrow-down-left",
  "heroicons/solid/phone-arrow-up-right",
  "heroicons/solid/phone-x-mark",
  "heroicons/solid/photo",
  "heroicons/solid/play",
  "heroicons/solid/play-circle",
  "heroicons/solid/play-pause",
  "heroicons/solid/plus",
  "heroicons/solid/plus-circle",
  "heroicons/solid/plus-small",
  "heroicons/solid/power",
  "heroicons/solid/presentation-chart-bar",
  "heroicons/solid/presentation-chart-line",
  "heroicons/solid/printer",
  "heroicons/solid/puzzle-piece",
  "heroicons/solid/qr-code",
  "heroicons/solid/question-mark-circle",
  "heroicons/solid/queue-list",
  "heroicons/solid/radio",
  "heroicons/solid/receipt-percent",
  "heroicons/solid/receipt-refund",
  "heroicons/solid/rectangle-group",
  "heroicons/solid/rectangle-stack",
  "heroicons/solid/rocket-launch",
  "heroicons/solid/rss",
  "heroicons/solid/scale",
  "heroicons/solid/scissors",
  "heroicons/solid/server",
  "heroicons/solid/server-stack",
  "heroicons/solid/share",
  "heroicons/solid/shield-check",
  "heroicons/solid/shield-exclamation",
  "heroicons/solid/shopping-bag",
  "heroicons/solid/shopping-cart",
  "heroicons/solid/signal",
  "heroicons/solid/signal-slash",
  "heroicons/solid/slash",
  "heroicons/solid/sparkles",
  "heroicons/solid/speaker-wave",
  "heroicons/solid/speaker-x-mark",
  "heroicons/solid/square-2-stack",
  "heroicons/solid/square-3-stack-3d",
  "heroicons/solid/squares-2x2",
  "heroicons/solid/squares-plus",
  "heroicons/solid/star",
  "heroicons/solid/stop",
  "heroicons/solid/stop-circle",
  "heroicons/solid/strikethrough",
  "heroicons/solid/sun",
  "heroicons/solid/swatch",
  "heroicons/solid/table-cells",
  "heroicons/solid/tag",
  "heroicons/solid/ticket",
  "heroicons/solid/trash",
  "heroicons/solid/trophy",
  "heroicons/solid/truck",
  "heroicons/solid/tv",
  "heroicons/solid/underline",
  "heroicons/solid/user",
  "heroicons/solid/user-circle",
  "heroicons/solid/user-group",
  "heroicons/solid/user-minus",
  "heroicons/solid/user-plus",
  "heroicons/solid/users",
  "heroicons/solid/variable",
  "heroicons/solid/video-camera",
  "heroicons/solid/video-camera-slash",
  "heroicons/solid/view-columns",
  "heroicons/solid/viewfinder-circle",
  "heroicons/solid/wallet",
  "heroicons/solid/wifi",
  "heroicons/solid/window",
  "heroicons/solid/wrench",
  "heroicons/solid/wrench-screwdriver",
  "heroicons/solid/x-circle",
  "heroicons/solid/x-mark",
  "internal/loading-spinner",
  "trophy-laurel",
] as const;
